var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.20832H3.54083",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02221 2.17714C6.59173 2.74665 6.59173 3.67001 6.02221 4.23953C5.4527 4.80904 4.52933 4.80904 3.95982 4.23953C3.39031 3.67001 3.39031 2.74665 3.95982 2.17714C4.52934 1.60762 5.4527 1.60762 6.02221 2.17714",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45166 3.20832H12.25",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02221 2.17714C6.59173 2.74665 6.59173 3.67001 6.02221 4.23953C5.4527 4.80904 4.52933 4.80904 3.95982 4.23953C3.39031 3.67001 3.39031 2.74665 3.95982 2.17714C4.52934 1.60762 5.4527 1.60762 6.02221 2.17714",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7.00001H10.465",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54833 7.00001H1.75",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0402 5.96879C10.6097 6.53831 10.6097 7.46167 10.0402 8.03119C9.4707 8.6007 8.54734 8.6007 7.97783 8.03119C7.40831 7.46167 7.40831 6.53831 7.97783 5.96879C8.54734 5.39928 9.4707 5.39928 10.0402 5.96879",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45166 10.7917H12.25",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 10.7917H3.535",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02221 9.76045C6.59173 10.33 6.59173 11.2533 6.02221 11.8228C5.4527 12.3924 4.52933 12.3924 3.95982 11.8228C3.39031 11.2533 3.39031 10.33 3.95982 9.76045C4.52934 9.19093 5.4527 9.19093 6.02221 9.76045",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilter);
export default __webpack_public_path__ + "static/media/ic-filter.f18173222261c6d2faa9bba3051fa68a.svg";
export { ForwardRef as ReactComponent };